/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Context_Menu_Auto_FormatInputs */

const en_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auto Format Text`)
};

const fr_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mise en forme auto du texte`)
};

const de_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text automatisch formatieren`)
};

const it_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formattazione automatica del testo`)
};

const ru_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Автоматическое форматирование текста`)
};

const es_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formato automático de texto`)
};

const zh_cn2_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`自动格式化文本`)
};

const ja_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`テキストの自動フォーマット`)
};

const hi_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टेक्स्ट को स्वचालित रूप से फॉर्मेट करें`)
};

const pt_pt2_context_menu_auto_format = /** @type {(inputs: Context_Menu_Auto_FormatInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Formatação automática de texto`)
};

/**
* | output |
* | --- |
* | "Auto Format Text" |
*
* @param {Context_Menu_Auto_FormatInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const context_menu_auto_format = /** @type {((inputs?: Context_Menu_Auto_FormatInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Context_Menu_Auto_FormatInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_context_menu_auto_format(inputs)
	if (locale === "de") return de_context_menu_auto_format(inputs)
	if (locale === "it") return it_context_menu_auto_format(inputs)
	if (locale === "ru") return ru_context_menu_auto_format(inputs)
	if (locale === "es") return es_context_menu_auto_format(inputs)
	if (locale === "zh-CN") return zh_cn2_context_menu_auto_format(inputs)
	if (locale === "ja") return ja_context_menu_auto_format(inputs)
	if (locale === "hi") return hi_context_menu_auto_format(inputs)
	if (locale === "pt-PT") return pt_pt2_context_menu_auto_format(inputs)
	return en_context_menu_auto_format(inputs)
});